// https://viacep.com.br/ws/89303106/json/
import axios from 'axios'

export async function getCep(cepValue: string) {
  const { data } = await axios.get(`https://viacep.com.br/ws/${cepValue}/json/`)

  return data
}
